export enum StoreMode {
    Internal = 'internal',
    External = 'external'
}